import icon1 from "../../assets/track_icons/icon1.webp";
import icon2 from "../../assets/track_icons/icon2.webp";
import icon3 from "../../assets/track_icons/icon3.webp";
import icon4 from "../../assets/track_icons/icon4.webp";
import icon5 from "../../assets/track_icons/icon5.webp";
import icon6 from "../../assets/track_icons/icon6.webp";
import icon7 from "../../assets/track_icons/icon7.webp";
import icon8 from "../../assets/track_icons/icon8.webp";
import icon9 from "../../assets/track_icons/icon9.webp";
import icon10 from "../../assets/track_icons/icon10.webp";
import icon11 from "../../assets/track_icons/icon11.webp";
import icon12 from "../../assets/track_icons/icon12.webp";
import icon13 from "../../assets/track_icons/icon13.webp";
import icon14 from "../../assets/track_icons/icon14.webp";
import icon15 from "../../assets/track_icons/icon15.webp";
import icon16 from "../../assets/track_icons/icon16.webp";
import icon17 from "../../assets/track_icons/icon17.webp";
import icon18 from "../../assets/track_icons/icon18.webp";
import icon19 from "../../assets/track_icons/icon19.webp";
import icon20 from "../../assets/track_icons/icon20.webp";
export const tracks = [
  { name:"Millet Biodiversity", icon: icon1  },
  { name: "Agroecology & Crop Physiology of Millets", icon:  icon2},
  { name: "Millet-Based Cropping Systems", icon:  icon3 },
  { name: "Intercropping, Polyculture & Sustainable Intensification", icon: icon4 },
  { name: "Breeding Innovations & Stress-Tolerant Millet Varieties", icon:   icon5},
  { name: "Soil–Millet Interactions", icon :icon6 },
  { name: "Climate-Resilient Farming Models", icon:  icon7 },
  { name: "Micro-Irrigation, Moisture Retention & Hydrology in Millets", icon:icon8 },
  { name: "Disaster-Resilient Agriculture", icon:icon9},
  { name: "Precision Agriculture for Millets", icon:icon10},
  { name: "AI/ML-Based Yield Forecasting & Pest Prediction", icon:icon11 },
  { name: "Post-Harvest Technologies", icon: icon12 },
  { name: "Millet Nutrition, Bioavailability & Health Benefits", icon:icon13 },
  { name: "Food Processing & Millet-Based Functional Foods", icon: icon14},
  { name: "Millet Entrepreneurship", icon:icon15 },
  { name: "Millet Policy Frameworks", icon:icon16 },
  { name: "Smart Farm Management for Dryland Crops", icon: icon17 },
  { name: "Physiology of Millets Under Stress Conditions", icon: icon18 },
   { name: "3D Printing", icon: icon19 },
  { name: "Millet Malting & Brewing Science", icon: icon20 },
  // { name: "Food Sciences", icon: icon20 },
];
